// extracted by mini-css-extract-plugin
export default {"Loginbody":"login_Loginbody__75KhE","loginform":"login_loginform__B7m8F"};